// ABOUTME: Route for /dashboard/usage — renders the usage charts page
import { UsagePage } from "@/components/dashboard/UsagePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/dashboard/usage")({
  component: UsagePage,
});
